<template>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h1 class="h4 mb-0">Downloads</h1>
    </div>
  </div>
  <div class="page-section page-section-last">
    <div class="row">
      <a href="../../resources/pdfs/code-template.pdf" target="_blank" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-file-earmark-text"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>Order Code Template</strong></div>
          <div class="text-description">Download our printable order code template </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </a>
      <router-link v-if="preferences.showReturnLabels" :to="{ name: 'ReturnLabel'}" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-box-seam"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>Freepost labels</strong></div>
          <div class="text-description">Create a freepost label to send your orders to us</div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </router-link>
      <div v-if="canSeePriceList" @click="openTurnaroundTimesPdf" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-clock-history"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>Turnaround Times</strong></div>
          <div class="text-description">Download our product turnaround times </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </div>
      <div v-if="canSeePriceList" @click="openPriceListPdf" class="quick-link col-md-6 mb-4">
        <div class="icon-column"><div class="icon"><div class="bi bi-tags"></div></div></div>
        <div class="text">
          <div><strong>Price List</strong></div>
          <div class="text-description">Download our price list</div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </div>

      <a href="../../resources/pdfs/DAMAS.pdf" target="_blank" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-patch-check"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>DAMAS</strong></div>
          <div class="text-description">Management system certification </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </a>

      <a href="../../resources/pdfs/DLA.pdf" target="_blank" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-person-check"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>DLA</strong></div>
          <div class="text-description">Certificate of membership </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </a>

      <a href="../../resources/pdfs/Infection Control Policy.pdf" target="_blank" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-activity"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>Infection Control Policy</strong></div>
          <div class="text-description">View our infection control policy </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </a>

      <a href="../../resources/pdfs/MHRA.pdf" target="_blank" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-file-medical"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>MHRA</strong></div>
          <div class="text-description">Medicines & healthcare products regulatory agency </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </a>

       <a href="../../resources/pdfs/gdc.pdf" target="_blank" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-people"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>GDC Registrations</strong></div>
          <div class="text-description">General Dental Council registrations</div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </a>

       <a href="../../resources/pdfs/Mouthguards.pdf" target="_blank" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi bi-magnet" viewBox="0 0 16 16">
                <path d="M8 1a7 7 0 0 0-7 7v3h4V8a3 3 0 0 1 6 0v3h4V8a7 7 0 0 0-7-7m7 11h-4v3h4zM5 12H1v3h4zM0 8a8 8 0 1 1 16 0v8h-6V8a2 2 0 1 0-4 0v8H0z"/>
              </svg>
          </div>
        </div>
        <div class="text">
          <div><strong>Mouthguard Guide</strong></div>
          <div class="text-description">View our mouthguard guide </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </a>

      

      <a href="../../resources/pdfs/Privacy Policy.pdf" target="_blank" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-shield-check"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>Privacy Policy</strong></div>
          <div class="text-description">View our privacy policy </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </a>

      <a href="../../resources/pdfs/Terms_and_conditions.pdf" target="_blank" class="quick-link col-md-6 mb-4">
        <div class="icon-column">
          <div class="icon">
            <i class="bi bi-file-earmark-font"></i>
          </div>
        </div>
        <div class="text">
          <div><strong>Terms and Conditions</strong></div>
          <div class="text-description">View our terms and conditions </div>
        </div>
        <div class="arrow"><img src="@/assets/images/arrow.png" /></div>
      </a>
    </div>
  </div>
</template>

<script>
    import api from "@/services/api";
    import base64 from "@/services/base64";

    export default {
        data() {
            return {
                preferences: {
                    showReturnLabels: false,
                },
            }
        },
        methods: {
            openTurnaroundTimesPdf: function() {
                var pdfWindow = window.open();
                pdfWindow.document.title = "Loading...";

                api
                .get('/api/v1/turnaround-times/' + this.$store.state.currentPracticeId)
                .then((response) => {
                    var blob = base64.toBlob(response.data, 'application/pdf');
                    pdfWindow.location = URL.createObjectURL(blob);
                })
                .catch((error) => {
                    pdfWindow.close();
                    console.log('Catch turnaround times pdf error', error);
                    alert('There was an error downloading the turnaround times, please try again later.');
                });
            },
            openPriceListPdf: function () {
              var pdfWindow = window.open();
              pdfWindow.document.title = "Loading...";

              api
                .get('/api/v1/priceList', {
                  params: { practice_id: this.$store.state.currentPracticeId },
                })
                .then((response) => {
                  var blob = base64.toBlob(response.data, 'application/pdf');
                  pdfWindow.location = URL.createObjectURL(blob);
                })
                .catch((error) => {
                  pdfWindow.close();
                  console.error('Something went wrong fetching the price list', error);
                  alert('There was an error downloading the price list please try again later');
                });
            },
            fetchPracticePrefs: function () {
              api
              .get('/api/v1/practices/' + this.$store.state.currentPracticeId + '/preferences', {
              })
              .then((response) => {
                  this.preferences = {
                      showReturnLabels: response.data.data.is_allowed_return_labels
                  };
              })
              .catch((reason) => {
                  console.log('Catch practice preferences error');
                  console.log(reason);
              });
          },
        },
        computed: {
            canSeePriceList() {
                if (this.$store.state.currentPractice === null) {
                    return false;
                }
                return this.$store.state.currentPractice.show_price_list;
            },
        },
        mounted() {
            this.fetchPracticePrefs();
        },
    }

</script>

<style scoped lang="scss">
.action
{
  padding-bottom: 20px;

  .action-link
  {
    display: flex;
    align-items: center;
  }

  .action-icon
  {
    aspect-ratio: 1/1;
    line-height: 0;
    font-size: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    width: 70px;
  }
}

.quick-link
{
  text-decoration: none;
  display: flex;
  cursor:pointer;

  .icon-column
  {
    display: flex;
    flex-direction: column;
    margin-right: $spacer;
  }

  .icon
  {
    background: $swift-lighter-grey;
    border-radius: 10px;
    aspect-ratio: 1/1;
    font-size: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70px;
  }

  .icon svg
  {
    width: 40px;
    height: 40px;
  }

  .text
  {
    flex-grow: 1;
    margin-right: $spacer;
  }

  .text-description
  {
    line-height: 1.3em;
  }

  .arrow
  {
    img
    {
      width: 30px;
      margin-top: 10px;
    }
  }

  &:hover
  {
    .icon
    {
      background: $swift-light-grey;
      transition: 0.5s;
    }
  }
}
</style>